import {
	CheckOutlined,
	LogoutOutlined,
	PhoneOutlined,
	SwapOutlined,
	UserOutlined,
} from "@ant-design/icons";
import { Avatar, Dropdown, Typography, theme } from "antd";
import { useLogout, useMe } from "@/modules/auth/queries/auth.query";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import { useOrganizationStore } from "@/shared/store/organization.store";

const { Text } = Typography;

export function UserDropdown() {
	const { data: meUser } = useMe();
	const storeUser = useAuthStore((state) => state.user);
	const user = meUser ?? storeUser;
	const { mutate: logout, isPending: isLoggingOut } = useLogout();
	const { token } = theme.useToken();

	const organizations = useOrganizationStore((s) => s.organizations);
	const selectedOrgId = useOrganizationStore((s) => s.selectedOrgId);
	const setSelectedOrgId = useOrganizationStore((s) => s.setSelectedOrgId);
	const currentOrg = useOrganizationStore((s) => s.getCurrentOrg());

	const initials = user?.fullname
		? user.fullname
				.split(" ")
				.map((w) => w[0])
				.join("")
				.slice(0, 2)
				.toUpperCase()
		: "";

	const menuItems = [
		{
			type: "group" as const,
			label: (
				<div className="px-1 py-1">
					<div className="font-semibold text-sm" style={{ color: token.colorText }}>
						{user?.fullname ?? "Foydalanuvchi"}
					</div>
					<div
						className="text-xs flex items-center gap-1"
						style={{ color: token.colorTextDescription }}
					>
						<PhoneOutlined /> {user?.phone}
					</div>
				</div>
			),
		},
		{ type: "divider" as const },
		...(organizations.length > 0
			? [
					{
						type: "group" as const,
						label: "Tashkilot",
						children: organizations.map((org) => ({
							key: `org-${org.id}`,
							icon:
								selectedOrgId === org.id ? (
									<CheckOutlined style={{ color: token.colorPrimary }} />
								) : (
									<SwapOutlined style={{ opacity: 0.3 }} />
								),
							label: (
								<span
									style={{
										fontWeight: selectedOrgId === org.id ? 600 : 400,
										color: selectedOrgId === org.id ? token.colorPrimary : undefined,
									}}
								>
									{org.name}
								</span>
							),
						})),
					},
					{ type: "divider" as const },
				]
			: []),
		{
			key: "logout",
			icon: <LogoutOutlined />,
			label: "Chiqish",
			danger: true,
		},
	];

	const handleMenuClick = ({ key }: { key: string }) => {
		if (key === "logout") {
			logout();
		} else if (key.startsWith("org-")) {
			const orgId = key.replace("org-", "");
			setSelectedOrgId(orgId);
		}
	};

	return (
		<Dropdown
			menu={{
				items: menuItems,
				onClick: handleMenuClick,
			}}
			placement="bottomRight"
			trigger={["click"]}
			disabled={isLoggingOut}
		>
			<button
				type="button"
				className="flex items-center gap-2.5 cursor-pointer px-3 py-1.5 rounded-lg transition-colors"
				style={{
					background: "transparent",
					border: "none",
					outline: "none",
				}}
			>
				<Avatar style={{ backgroundColor: token.colorPrimary, flexShrink: 0 }} size={36}>
					{initials || <UserOutlined />}
				</Avatar>
				<div className="hidden sm:flex flex-col items-start leading-tight">
					<Text className="text-sm font-medium" style={{ color: token.colorText }}>
						{user?.fullname ?? "Foydalanuvchi"}
					</Text>
					<Text className="text-xs" style={{ color: token.colorTextDescription }}>
						{currentOrg?.name ?? "Tashkilot tanlanmagan"}
					</Text>
				</div>
			</button>
		</Dropdown>
	);
}
